import React, { useState } from "react";
import { useNotify, useRefresh } from "react-admin";
import PropTypes from "prop-types";
import Dropzone from "react-dropzone";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import { Box, Flex, Text } from "rebass";
import { UploadClientCSV } from "../../restClient";
const UploadCsv = (props) => {
  const {
    accept,
    disableClick,
    maxSize,
    minSize,
    multiple,
    translate,
    handleSubmit,
    urlPath,
    params,
    onClose,
  } = props;
  /**
   * type: type,
    start_at: start_at,
    end_at: end_at,
    name: state.name,
    country_id: state.country_id,
   */
  const notify = useNotify();
  const refresh = useRefresh();
  const [loading, setLoading] = useState(false);
  const onDrop = (accepted, rejected) => {
    if (accepted.length > 0 && rejected.length === 0) {
      if (params.name !== "" && params.country_id !== "") {
        // console.log(period, accepted);
        let formData = new FormData();
        accepted.forEach((file) => {
          //   console.log(file);
          formData.append("file", file);
        });
        formData.append("type", params.type);
        formData.append("end_at", params.end_at);
        formData.append("start_at", params.start_at);
        formData.append("name", params.name);
        formData.append("country_id", params.country_id);
        // console.log(urlPath, formData);
        setLoading(true);
        UploadClientCSV(formData, urlPath)
          .then((response) => response.json())
          .then((data) => {
            // console.log(data);
            setLoading(false);
            if (data) {
              if (data && Array.isArray(data) && data.length > 0) {
                handleSubmit(data);
              } else {
                if (data && data.message && data.message !== "") {
                  notify(data.message, "warning");
                } else {
                  onClose();
                  notify("resources.pricebook.messages.success", "success");
                  refresh();
                }
              }
            } else {
              notify("resources.pricebook.messages.message_failed", "warning");
            }
          })
          .catch((e) => {
            notify("resources.pricebook.messages.message_failed", "warning");
            setLoading(false);
          });
      } else {
        notify("resources.pricebook.messages.please_select", "warning");
      }
    }
  };
  return (
    <Box p={[2]}>
      <Dropzone
        onDrop={onDrop}
        accept={accept}
        disableClick={disableClick}
        maxSize={maxSize}
        minSize={minSize}
        multiple={multiple}
      >
        {({ getRootProps, getInputProps }) => (
          <div>
            <div {...getRootProps()}>
              {!disableClick && <input {...getInputProps()} />}

              <Button
                variant={"contained"}
                color='primary'
                disabled={disableClick}
                style={{
                  textTransform: "capitalize",
                  width: 200,
                  borderRadius: 24,
                }}
              >
                {translate("resources.buttons.upload_csv")}
              </Button>
              {loading && (
                <Flex flexDirection={"row"} alignItems='center' p={[2]}>
                  <CircularProgress /> <Text px={[2]}>Loading ...</Text>
                </Flex>
              )}
            </div>
          </div>
        )}
      </Dropzone>
    </Box>
  );
};

UploadCsv.propTypes = {
  accept: PropTypes.string,
  children: PropTypes.element,
  disableClick: PropTypes.bool,
  elStyle: PropTypes.object,
  input: PropTypes.object,
  maxSize: PropTypes.number,
  minSize: PropTypes.number,
  multiple: PropTypes.bool,
  style: PropTypes.object,
  placeholder: PropTypes.node,
  updateField: PropTypes.func,
};

UploadCsv.defaultProps = {
  addLabel: false,
  addField: true,
  multiple: false,
  maxSize: 1000000,
  accept: ".csv, application/vnd.ms-excel, text/csv",
  onUpload: () => {},
};

export default UploadCsv;
